import moment from 'moment';

const weekday = moment().weekday();

export default {
  yesterday: {
    text: '昨天',
    data: [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
  },

  dayBeforeYesterday: {
    text: '前天',
    data: [moment().subtract(2, 'day'), moment().subtract(2, 'day')],
  },

  today: {
    text: '今天',
    data: [moment(), moment()],
  },

  last7Days: {
    text: '最近7天',
    data: [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
  },

  last30Days: {
    text: '最近30天',
    data: [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
  },

  thisWeek: {
    text: '本周',
    data: [
      moment().weekday(weekday === 0 ? weekday - 6 : 1),
      moment().weekday(moment().subtract(1, 'day').weekday()),
    ],
  },

  lastWeek: {
    text: '上周',
    data: [moment().weekday(-6), moment().weekday(0)],
  },

  thisMonth: {
    text: '本月',
    data: [moment().startOf('month'), moment().subtract(1, 'day')],
  },

  lastMonth: {
    text: '上个月',
    data: [
      moment()
        .month(moment().month() - 1)
        .startOf('month'),
      moment()
        .month(moment().month() - 1)
        .endOf('month'),
    ],
  },
};
